var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/1.25/ic_search/light gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/1.25/ic_search/light-gray",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_search"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    strokeOpacity: 0.00784313771,
    stroke: "#000000",
    strokeWidth: 1.33333335e-11,
    points: "0 0 16.0000006 0 16.0000006 16.0000006 0 16.0000006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52455637,2.80877677 C7.73054288,2.01476356 6.78957026,1.62499993 5.66666663,1.625 C4.54376247,1.62499993 3.60278987,2.01476352 2.80877669,2.80877669 C2.01476352,3.60278987 1.62499993,4.54376247 1.625,5.66666671 C1.62499993,6.78957026 2.01476356,7.73054288 2.80877662,8.52455622 C3.60278973,9.31856906 4.54376244,9.70833275 5.66666634,9.70833333 C6.78957028,9.70833275 7.73054302,9.31856902 8.52455614,8.52455645 C9.31856902,7.73054302 9.70833275,6.78957028 9.70833333,5.66666634 C9.70833275,4.54376244 9.31856906,3.60278973 8.52455637,2.80877677 Z M9.40843962,9.40843993 C8.38000589,10.4368729 7.12109115,10.9583326 5.66666634,10.9583333 C4.21224155,10.9583326 2.95332676,10.436873 1.92489314,9.40843969 C0.896459571,8.38000576 0.37499991,7.1210908 0.375,5.66666671 C0.37499991,4.2122419 0.896459553,2.95332688 1.92489322,1.92489322 C2.95332688,0.896459553 4.2122419,0.37499991 5.66666663,0.375 C7.1210908,0.37499991 8.38000576,0.896459571 9.40843985,1.92489329 C10.436873,2.95332676 10.9583326,4.21224155 10.9583333,5.66666634 C10.9583326,7.12109115 10.4368729,8.38000589 9.40843962,9.40843993 Z",
    id: "Stroke-2",
    fill: "#C3C6D6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12472516,9.04194147 C8.88064748,8.79786379 8.88064748,8.40213568 9.12472516,8.158058 C9.36880284,7.91398031 9.76453096,7.91398031 10.0086086,8.158058 L14.5419427,12.6913921 C14.9193543,13.0688036 14.9193543,13.6645312 14.5419427,14.0419427 L14.0752756,14.5086098 C13.6978641,14.8860215 13.1021364,14.8860215 12.7279863,14.5118474 L8.16131938,10.0118461 C7.91545368,9.76956966 7.91254404,9.37385224 8.15482051,9.12798654 C8.39709698,8.88212084 8.79281439,8.8792112 9.03868009,9.12148767 L13.3984669,13.4176516 L13.4494511,13.3666674 L9.12472516,9.04194147 Z M13.6086085,13.6247265 C13.607686,13.623804 13.6067577,13.6228893 13.6058235,13.6219822 L13.6086085,13.6247265 Z",
    id: "Stroke-3",
    fill: "#C3C6D6",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.37969b789e05ca8011ab10cc88f5b1cd.svg";
export { ForwardRef as ReactComponent };